import { Icon, type IconName } from '@core/designsystem';
import { TABS, type Tab } from './routes';

/**
 * Нижняя навигация: четыре раздела и поиск.
 *
 * Поиск стоит здесь, а не иконкой в правом верхнем углу ([D-11](docs/DECISIONS.md)):
 * верхние углы при одноручном хвате на 6.7″ недостижимы, а поиск — способ доступа
 * наравне со списком.
 *
 * Высота задана минимальной, а не фиксированной: при системном шрифте 200 % панель
 * растёт, а не режет подписи.
 */
export function BottomBar({
  tab,
  searching,
  onSelect,
  onSearch,
}: {
  tab: Tab;
  searching: boolean;
  onSelect: (tab: Tab) => void;
  onSearch: () => void;
}) {
  return (
    <nav className="bottom-bar" aria-label="Разделы">
      {TABS.map((item) => {
        const active = !searching && item.tab === tab;

        return (
          <button
            key={item.tab}
            type="button"
            className="bottom-bar__item"
            aria-current={active ? 'page' : undefined}
            onClick={() => onSelect(item.tab)}
          >
            <span className="bottom-bar__pill">
              <Icon name={item.icon as IconName} filled={active} size={24} />
            </span>
            <span className="bottom-bar__label">{item.label}</span>
          </button>
        );
      })}

      <button
        type="button"
        className="bottom-bar__item"
        aria-current={searching ? 'page' : undefined}
        onClick={onSearch}
      >
        <span className="bottom-bar__pill">
          <Icon name="search" size={24} />
        </span>
        <span className="bottom-bar__label">Поиск</span>
      </button>
    </nav>
  );
}
